// extracted by mini-css-extract-plugin
export var checkbox = "styles-module__checkbox___Idnf3";
export var formContainer = "styles-module__formContainer___G_K1N";
export var formSection = "styles-module__formSection___X45r7";